/**
 * Placeholder YouTube URL для `<VideoButton>` на Экране 2.0 «Главная».
 * Будет заменён на реальный embed когда продюсер запишет вступительный
 * ролик (B-008 / PRD §16.4).
 */
export const HOME_VIDEO_URL = 'https://www.youtube.com/embed/dQw4w9WgXcQ';
